import store from 'store';

/**
 * @deprecated use "isFeatureEnabled" from "useClientFeatures" hook
 */
export function IsFeatureSupported(clientFeaturePermissions) {
  const state = store.getState();
  let retVal = false;
  if (
    state.user.loggedUser.enabledFeatures &&
    state.user.loggedUser.enabledFeatures.some(x => x === clientFeaturePermissions)
  ) {
    retVal = true;
  }

  return retVal;
}
